var exports = {
  "Pf": "x24da60e8--6871e0--label",
  "jD": "x24da60e8--6871e0--hide",
  "hF": "x24da60e8--6871e0--input",
  "Qs": "x24da60e8--6871e0--content",
  "Qq": "x24da60e8--6871e0--text",
  "Fb": "x24da60e8--6871e0--file-icon",
};

module.exports = exports;
